import Loading from "~/components/Loading"
import BeardItemCard from "./BeardItemCard"

export default function BeardNotificationsList({ items = [] }) {
    function handleAction(e, item, action) {
        e.preventDefault();

        if (action.slice(0, 1) === '/') window.location = action;
        if (action === 'view') window.location = `/flights/${item.id}`;
        if (action === 'data') window.location = `/flights/data/${item.id}`;

        if (action === 'delete') {
            setIsSubmitting(true)
            requestAction.deleteRequest(item.id)
                .then(response => {
                    if (response.status === 'success') {
                        fetch();
                    }
                })
                .finally(() => {
                    setIsSubmitting(true)
                })
        }
    }

    return <React.Fragment>
        {items.length > 0 && items.map(item => <BeardItemCard key={`${item.id}-${item.code}`} item={item} onActionPress={handleAction} />)}
    </React.Fragment>
}
